<div class="pageheader">
  <div class="page-title">
    <h1>User details - {{(selectedUser?.DisplayName || 'New user')}}</h1>
    <div class="btn-group"  >
      <button class="btn btn-link"  [class.invisible]="!selectedUser || !selectedUser?.UserId" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'User_Action_ShowLog'" [disabled]="!selectedUser && !selectedUser?.UserId"
        [title]="'Logs for ' + $safeNavigationMigration(selectedUser?.DisplayName)">
        <app-change-log-link-entity type="User" [id]="$safeNavigationMigration(selectedUser?.UserId)"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="form-group btn-toolbar " data-toggle="buttons" [hidden]="!users || users?.length < 2">

  @for (user of users; track user) {
    <label class="btn btn-info-button" [class.active]="selectedUser?.UserId == user?.UserId">
      <input type="radio" [value]="user" [ngModel]="selectedUser" (ngModelChange)="selectedUser = $event">
      <span class="PartnerIn">{{user?.DisplayName}}</span>
      <span class="hr"></span>
      <!-- TODO: CSS til Søren -->
      <span class="id">{{user?.Credentials?.UserName}}</span>
      <span class="PartnerOut">{{user?.EmailAddress}}</span>
      @if (!user?.IsDisabled) {
        <span class="PartnerOut label label-default">Enabled</span>
      }
      @if (user?.IsDisabled) {
        <span class="PartnerOut label label-warning">Disabled</span>
      }
    </label>
  }
</div>
<div class="btn-toolbar">
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'User_Action_UserCreate'" [class.invisible]="isEditing" [disabled]="isEditing" (click)="createNew()">New User</button>
  </div>
  @if (!selectedUser?.IsBuiltIn) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'User_Action_UserDelete'" [class.invisible]="!selectedUser || !selectedUser?.UserId || isEditing" (click)="delete()">Delete</button>
    </div>
  }
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'User_Action_UserRevokeTokens'" [class.invisible]="!selectedUser || !selectedUser?.UserId || isEditing" (click)="revokeTokens()">Revoke all tokens</button>
  </div>
  @if (!hideButtonForBuiltInUser) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'User_Action_UserEdit'" [class.invisible]="!selectedUser || isEditing" [disabled]="$safeNavigationMigration(selectedUser?.IsDisabled)" (click)="disableUser()">Disable user</button>
    </div>
  }
  <div class="btn-group">
    <button class="btn btn-warning btn-sm" *bizPermissionRequired="'User_Action_UserEdit'" [class.invisible]="!selectedUser || !selectedUser?.IsDisabled || isEditing" (click)="enableUser()">User is disabled (click here to enable)</button>
  </div>
</div>
<ep-user-profile [loadCurrentUser]="false" [currentUser]="selectedUser" (userSaved)="userSaved($event)" (editChanged)="isEditing = $event" (cancelPressed)="cancelPressed()"></ep-user-profile>
